module.exports = __webpack_public_path__ + "static/mo09-20702b5d4ab2449db4cae0e2e0cb2b90.png";